import React, { useState } from 'react';

const EmdReservation = ({ num, data, handleChange }) => {
    const [showPopup, setShowPopup] = useState(false);

    return (
        <table
            className='table_style4 bdt mb70'
            cellPadding='0'
            cellSpacing='0'
            id='airCertInfoTbl'
            id-data={num}
        >
            <colgroup>
                <col style={{ width: '190px' }} />
                <col style={{ width: '410px' }} />
                <col style={{ width: '190px' }} />
                <col style={{ width: 'auto' }} />
            </colgroup>
            <tbody>
                <tr>
                    <th>
                        <p className='essential'>요청항목</p>
                    </th>
                    <td colSpan={3}>
                        <input
                            type='radio'
                            name='ReqGubun'
                            id='ReqGubunEMD'
                            class='requiredField'
                            style={{ width: '370px' }}
                            value="EMD"
                            defaultChecked
                            onChange={(e) => {
                                handleChange(
                                    num,
                                    "reqGubun",
                                    e.target.value
                                );
                                setShowPopup(false); // 티켓 요청 클릭 시 팝업 띄움
                            }}
                        /> EMD REASSOCIATE 요청
                        <input
                            type='radio'
                            name='ReqGubun'
                            id='ReqGubunTKT'
                            class='requiredField'
                            style={{ width: '370px', marginLeft: '20px' }}
                            value="TKT"
                            onChange={(e) => {
                                handleChange(
                                    num,
                                    "reqGubun",
                                    e.target.value
                                );
                                setShowPopup(true); // 티켓 요청 클릭 시 팝업 띄움
                            }}
                        /> 티켓 REASSOCIATE 요청

                        {/* 조건부 렌더링으로 팝업 표시 */}
                        {showPopup && (
                            <div
                            style={{
                                position: "fixed",
                                top: "30%",
                                left: "30%",
                                width: "1000px",
                                padding: "30px",
                                backgroundColor: "white",
                                border: "1px solid #ccc",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                fontSize: "18px",
                                zIndex: 1000,
                            }}
                            >
                            {/* <h3>티켓 요청 팝업</h3> */}
                            <p>티켓을 기존 여정으로 원복하는 경우,<br/>
                            REASSOCIATE 처리가 불가하며 자체 재발행 진행 해주시기 바랍니다.<br/><br/>
                            별도 AUTH 코드는 없으며, 아래 사항을 티켓 Remarks 사항에 입력 후 자체 재발행 바랍니다.<br/>
                            *Remarks: REISSUE DUE TO REASSO ORG TKT WIZ PNR WITHOUT CHG FLT NUMBER & DATE / 재발행일<br/>
                            (단, 기존 Class 및 여정이 일치하지 않은 경우는 허용 되지 않으며 ADM 발생 되오니 주의 바랍니다.)</p>
                            {
                                <div className='btn_area'>
                                    <button className='btn36 gray' style={{marginTop:30, width:100}} onClick={() => setShowPopup(false)}>닫기</button>
                                </div>
                            }
                            </div>
                        )}
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>항공사 예약번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            name='PaxBirthday'
                            id='PaxBirthday_0'
                            class='requiredField'
                            style={{ width: '370px' }}
                            value={data.air_pnr}
                            onChange={(e) => handleChange(num, 'air_pnr', e.target.value.replace(/[\u3131-\u318F\uAC00-\uD7A3]/g, '').toUpperCase())}
                        />
                    </td>
                    <th>
                        <p class='essential'>탑승객명</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            name='PaxBirthday'
                            id='PaxBirthday_0'
                            class='requiredField'
                            style={{ width: '370px' }}
                            value={data.tkt_number}
                            onChange={(e) => handleChange(num, 'tkt_number', e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential'>ORIGIN 티켓번호</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            name='PaxBirthday'
                            id='PaxBirthday_0'
                            class='requiredField'
                            style={{ width: '370px' }}
                            value={data.org_flight}
                            onChange={(e) => handleChange(num, 'org_flight', e.target.value.replace(/[A-Za-zㄱ-힣]/g, ''))}
                        />
                    </td>
                    <th>
                        <p class='essential'>REASSO 요청 EMD</p>
                    </th>
                    <td>
                        <input
                            type='text'
                            name='PaxBirthday'
                            id='PaxBirthday_0'
                            class='requiredField'
                            placeholder='REASSO 요청 EMD 번호'
                            style={{ width: '370px' }}
                            value={data.new_flight}
                            onChange={(e) => handleChange(num, 'new_flight', e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p className='essential red'>좌석번호 / 편명 및 날짜</p>
                    </th>
                    <td colSpan={3}>
                        <input
                            type='text'
                            name='PaxBirthday'
                            id='PaxBirthday_0'
                            class='requiredField'
                            style={{ width: '100%' }}
                            placeholder='예) 23A/PR2975/31MAR'
                            value={data.tkt_email_address}
                            onChange={(e) => handleChange(num, 'tkt_email_address', e.target.value)}
                        />
                    </td>
                </tr>
                <tr>
                    <th>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;비고</p>
                    </th>
                    <td colSpan={3}>
                        <textarea
                            name='PaxBirthday'
                            id='remark'
                            class='remarkInput'
                            value={data.freeMemo}
                            onChange={(e) => handleChange(num, 'freeMemo', e.target.value)}
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default EmdReservation;
